import { Option } from '@com-delta-omnichannel/mach';
import {
  AirportCode,
  DropdownItem,
  FromAndTo
} from '@com-delta-omnichannel/mach-core-js';
import { TriggerLocation } from '../../../models/search-modal-events-object.interface';

export const mapOptionsToDropdownItem = (
  options: Option[],
  iconOverride?: string
) => {
  return (
    options?.map(
      (option: Option) =>
        ({
          label: option.label,
          value: option.value,
          selected: option?.selected,
          icon: iconOverride || option?.icon?.src
        } as DropdownItem)
    ) ?? []
  );
};

export const generateRandomIdString = () =>
  Math.random().toString(36).substring(2, 15);

export const formatDate = (date?: Date | null) => {
  if (date) {
    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric'
    };
    return new Date(date).toLocaleDateString('en-US', options);
  }
  return '';
};

export const focusRoutepicker = (
  triggerLocation: TriggerLocation | undefined,
  routePicker: FromAndTo | AirportCode
) => {
  if (triggerLocation === 'origin' || triggerLocation === 'destination') {
    routePicker.focus(triggerLocation);
  }
};
